/* On-site help routing only. No requests, storage, tracking or form submission. */
(() => {
  'use strict';
  if (window.CgauHelpRouting) { window.CgauHelpRouting.scan(document); return; }
  const instances = new Map();
  const topics = {
    choosing: 'Choosing what to buy', compatibility: 'Compatibility',
    setup: 'Setup help', delivery: 'Delivery / order help', problem: 'Product support / return'
  };
  class HelpRouting {
    constructor(root) {
      this.root = root;
      this.links = [...root.querySelectorAll('[data-help-route]')];
      this.panels = [...root.querySelectorAll('[data-help-panel]')];
      this.cleanups = [];
      this.listen(root, 'click', event => {
        const target = event.target instanceof Element ? event.target.closest('a') : null;
        if (!target || !root.contains(target) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const route = target.dataset.helpRoute, enquiry = target.dataset.helpEnquiry;
        if (topics[route]) {
          event.preventDefault();
          if (location.hash !== `#${route}`) history.pushState(null, '', `#${route}`);
          this.activate(route, true);
        } else if (topics[enquiry]) {
          const message = document.querySelector('.contact-form__form textarea[name="contact[body]"]');
          if (!message) return; // The ordinary anchor remains the no-script fallback.
          event.preventDefault();
          const oldValue = message.value;
          const previousTopic = message.dataset.cgauHelpTopic;
          const previousPrefix = topics[previousTopic] ? `Help topic: ${topics[previousTopic]}\n\n` : '';
          const content = previousPrefix && oldValue.startsWith(previousPrefix) ? oldValue.slice(previousPrefix.length) : oldValue;
          message.dataset.cgauHelpTopic = enquiry;
          message.value = `Help topic: ${topics[enquiry]}\n\n` + content;
          message.dispatchEvent(new Event('input', {bubbles:true}));
          message.focus();
          message.setSelectionRange(message.value.length, message.value.length);
          message.scrollIntoView({block:'center', behavior:'auto'});
          const status = root.querySelector('[data-help-status]');
          if (status) status.textContent = `${topics[enquiry]} topic added. Add your details and question, review your message, then choose Send enquiry.`;
        }
      });
      const fromHash = () => {
        const route = location.hash.slice(1);
        if (topics[route]) this.activate(route, false);
        else if (!route) this.activate('choosing', false);
      };
      this.listen(window, 'hashchange', fromHash);
      this.listen(window, 'popstate', fromHash);
      root.dataset.helpEnhanced = 'true';
      this.activate(topics[location.hash.slice(1)] ? location.hash.slice(1) : 'choosing', false);
    }
    listen(target, event, fn) { target.addEventListener(event,fn);this.cleanups.push(()=>target.removeEventListener(event,fn)); }
    activate(route, focus) {
      this.root.dataset.helpActive = route;
      for (const link of this.links) {
        if (link.dataset.helpRoute === route) link.setAttribute('aria-current','true');
        else link.removeAttribute('aria-current');
      }
      for (const panel of this.panels) panel.hidden = panel.dataset.helpPanel !== route;
      if (focus) this.panels.find(panel=>panel.dataset.helpPanel===route)?.querySelector('h2')?.focus({preventScroll:true});
    }
    destroy() {
      this.cleanups.forEach(cleanup=>cleanup());
      this.panels.forEach(panel=>{panel.hidden=false;});
      this.links.forEach(link=>link.removeAttribute('aria-current'));
      delete this.root.dataset.helpEnhanced;delete this.root.dataset.helpActive;
      instances.delete(this.root);
    }
  }
  const scan = scope => {
    const roots = scope.matches?.('[data-cgau-help]') ? [scope] : [...scope.querySelectorAll('[data-cgau-help]')];
    roots.forEach(root=>{if(!instances.has(root))instances.set(root,new HelpRouting(root));});
  };
  window.CgauHelpRouting={scan,destroyAll:()=>[...instances.values()].forEach(instance=>instance.destroy())};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document),{once:true});
  else scan(document);
  document.addEventListener('shopify:section:load',event=>scan(event.target));
  document.addEventListener('shopify:section:unload',event=>[...instances.values()].filter(instance=>event.target.contains(instance.root)).forEach(instance=>instance.destroy()));
})();
